module.exports = __webpack_public_path__ + "files/7c94b73129a90a40ecea4dbc41a1be3b.png";